import { useSelector, useDispatch } from 'react-redux';
import { IRootState } from '../../../store/reducers';
import './style.scss';
import { IAPIServiceConfigItem } from '../../../model/api-modules';
import React, { useEffect, useState } from 'react';
import { getServiceTopCategory, sortServiceConfig } from '../lib';
import { IGameURLParams } from '../../../model';
import { useParams } from 'react-router-dom';
import {
  getGameFavoriteTotalAction,
  getServiceMyFavoriteListAction,
} from '../../../store/modules/games';
import { SvgIcon } from '../../component/svg-icon';
import { SvgIconName } from '../../component/svg-icon/model';
import { GameBaseInfoComponent } from '../overview/game-base-info';
import { DescriptionModal } from '../services/description-modal';
import { SingleServiceBlockComponent } from '../services/single-service-block';
import { FavoriteButton } from '../services/favorite-button';

export const ConsoleAllProduct = () => {
  const commonDispatch = useDispatch<any>();
  const routeParams = useParams<IGameURLParams>();

  const servicesConfig = useSelector(
    (state: IRootState) => state.games.allServiceConfig
  );
  const myFavoriteList = useSelector(
    (state: IRootState) => state.games.myFavoriteList
  );
  const serviceFavoriteTotal = useSelector(
    (state: IRootState) => state.games.serviceFavoriteTotal
  );
  const gameList = useSelector((state: IRootState) => state.games.games);

  const [serviceDescriptionModalID, setServiceDescriptionModalID] = useState<
    number | null
  >(null);

  useEffect(() => {
    getServiceMyFavoriteListAction(commonDispatch, routeParams.gameId)();
    getGameFavoriteTotalAction(commonDispatch)();
  }, []);

  const getSelectedGameItem = () => {
    return gameList.find((item) => item.gameID === routeParams.gameId);
  };

  const selectedGame = getSelectedGameItem();

  const renderServiceItems = (
    serviceItems: ReadonlyArray<IAPIServiceConfigItem>
  ) => {
    return serviceItems.map((item) => {
      const favoriteTotalItem = serviceFavoriteTotal.find(
        (totalItem) => totalItem.ServiceID === item.id
      );
      if (item.Status === 0) {
        return null;
      }
      return (
        <SingleServiceBlockComponent
          serviceConfig={item}
          onClick={() => setServiceDescriptionModalID(item.id)}
          renderFavoriteButton={
            <FavoriteButton
              favoriteTotal={favoriteTotalItem?.TotalCount}
              favoriteList={myFavoriteList}
              serviceConfig={item}
              showTotal={false}
            />
          }
        />
      );
    });
  };

  const renderCategoryRow = (categoryName: string, index: number) => {
    const serviceItems = sortServiceConfig(servicesConfig || []).filter(
      (item) => item.ParentName === categoryName
    );
    return (
      <div key={index} className="category-box">
        <div className="category-header">
          <span className="icon">
            <SvgIcon icon={categoryName as SvgIconName} width={14} />
          </span>
          <span className="name">{categoryName}</span>
        </div>
        <div className="category-items">{renderServiceItems(serviceItems)}</div>
      </div>
    );
  };

  const renderCategoryContent = () => {
    const category = getServiceTopCategory(servicesConfig || []);
    return (
      <div className="all-product-content">
        {category.map((item, index) => {
          return renderCategoryRow(item, index);
        })}
      </div>
    );
  };

  const renderServiceDescriptionModal = () => {
    if (serviceDescriptionModalID !== null) {
      const configItem = servicesConfig?.find(
        (item) => item.id === serviceDescriptionModalID
      );
      if (configItem && serviceDescriptionModalID === configItem.id) {
        return (
          <DescriptionModal
            onCancel={() => setServiceDescriptionModalID(null)}
            configItem={configItem}
            favoriteList={myFavoriteList}
            favoriteTotalList={serviceFavoriteTotal}
          />
        );
      }
    }
    return null;
  };

  return (
    <div className="all-product-box">
      {selectedGame ? (
        <GameBaseInfoComponent selectedGame={selectedGame} />
      ) : null}
      {renderCategoryContent()}
      {renderServiceDescriptionModal()}
    </div>
  );
};
